import { registerLocale, getNames, type LocaleData } from 'i18n-iso-countries'
import en from 'i18n-iso-countries/langs/en.json'
import type { SelectOption } from '@/components/ui'

registerLocale(en as LocaleData)

/** ISO 3166-1 alpha-2 → English country name, sorted by label. */
export const NATIONALITY_OPTIONS: SelectOption[] = Object.entries(getNames('en'))
  .map(([value, label]) => ({ value, label: label as string }))
  .sort((a, b) => a.label.localeCompare(b.label))
